module.exports = require("live/components/forms/ui/filter-dropdown");